import styled, { keyframes } from "styled-components/macro";
import { THEME_COLOR } from "../vars";

const loaderKeyframes = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Loader = styled.div`
  border-radius: 10000px;
  width: 50px;
  height: 50px;
  border: 4px solid transparent;
  border-left-color: ${THEME_COLOR};
  animation: 1s ${loaderKeyframes} linear infinite;
  margin: auto;
  margin-bottom: 20px;
`;

export default Loader;

export const SmallLoader = styled(Loader)`
  width: 25px;
  height: 25px;
  border-width: 2px;
`;
